export const createBookingLink = (token: string) =>
  window.open(`${import.meta.env.VITE_MONOLITH_HOST}/ticket/${token}`, '_blank');
